/*
  VAIROK · portada: carruseles de producto (sections/vk-home-carousel.liquid).
  El carril es un scroll horizontal nativo con scroll-snap (funciona sin JS, con dedo, rueda y teclado).
  Este script solo añade: flechas (avanzan una «página» de tarjetas), estado de las flechas y la barrita de progreso.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__vkhCar) return;
    root.__vkhCar = true;

    var track = root.querySelector('[data-vkh-track]');
    var prev = root.querySelector('[data-vkh-prev]');
    var next = root.querySelector('[data-vkh-next]');
    var arrows = root.querySelector('.vkh-car__arrows');
    var bar = root.querySelector('.vkh-car__bar');
    var thumb = root.querySelector('[data-vkh-thumb]');
    if (!track) return;

    var queued = false;

    function slides() {
      return track.querySelectorAll('.vkh-car__slide');
    }

    function step() {
      var s = slides();
      if (s.length < 2) return track.clientWidth;
      var w = s[1].getBoundingClientRect().left - s[0].getBoundingClientRect().left;
      var perPage = Math.max(1, Math.round(track.clientWidth / w)); // tarjetas enteras por pantalla (el último hueco no lleva separación)
      return w * perPage;
    }

    function update() {
      queued = false;
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      if (arrows) arrows.hidden = !overflow;
      if (bar) bar.hidden = !overflow;
      if (!overflow) return;
      var x = Math.min(Math.max(track.scrollLeft, 0), max);
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (bar && thumb) {
        var bw = bar.clientWidth;
        var tw = Math.max(16, Math.round(bw * track.clientWidth / track.scrollWidth));
        thumb.style.width = tw + 'px';
        thumb.style.transform = 'translateX(' + Math.round((bw - tw) * (x / max)) + 'px)';
      }
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('load', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(track);
    update();
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-vkh-carousel]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Editor del tema: secciones que se vuelven a pintar
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
